/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LoadingService} from '../shared/loading/loading-service/loading.service';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WelcomePageComponent implements OnInit {
    constructor(private loadingService: LoadingService) {
        loadingService.stop();
    }

    ngOnInit(): void {
    }
}
